export default "__VITE_ASSET__DBNas2qA__"